<template>
  <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-hidden="true" :ref="modalId">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header text-left">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
          <h4 class="modal-title">
            {{modalState}}&nbsp;&nbsp;
            <label class="badge bg-red" v-if="state == 3 && !editState && optionInfo.is_mandatory">必選</label>
            <label class="badge bg-blue" v-if="state == 3 && !editState && optionInfo.is_common">常見</label>
          </h4>
        </div>
        <div class="modal-body">
          <div class="text-right" style="margin-right: 10px;">
            <button class="btn btn-danger icon-modal-del" v-if="editState" @click="show.delNotify = !show.delNotify"><i class="fa fa-trash" aria-hidden="true"></i></button>
            <button class="btn btn-primary icon-modal-edit" v-if="!editState && state == 3" @click.prevent="editState = true"><i class="fa fa-pencil" aria-hidden="true"></i></button>
            <button class="btn btn-primary icon-modal-edit" v-if="editState" @click.prevent="editState = false"><i class="fa fa-eye" aria-hidden="true"></i></button>
            <div v-if="show.delNotify" class="del-c-block">
              <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                  <div class="modal-header text-left">
                    <h4 class="modal-title">提醒</h4>
                  </div>
                  <div class="modal-body text-left">
                    <p>確定刪除此商品？</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-default" @click="show.delNotify = false">取消</button>
                    <button type="button" class="btn btn-danger" @click="delOption">刪除</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- info start-->
          <div class="box-body form" v-if="state == 3 && !editState">
            <div>
              <div class="input-group">
                <span class="input-group-addon">分類</span>
                <div class="form-control form-info text-left">{{optionInfo.sub_type}}</div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">選項名稱</span>
                <div class="form-control form-info text-left">{{getSubType(optionInfo.name)}}</div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">調整類別名稱</span>
                <div class="form-control form-info text-left">{{adjustName}}</div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">排序</span>
                <div class="form-control form-info text-left">{{optionInfo.sort}}</div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">購買數</span>
                <div class="form-control form-info text-left">{{optionInfo.min_limit}} ～ {{maxAmount(optionInfo.max_limit)}}</div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">價格</span>
                <div class="form-control form-info text-left">${{optionInfo.price}} ({{getPriceType(optionInfo.price_type)}})</div>
              </div>
              <br />
            </div>
            <div v-if="optionInfo.calorie">
              <div class="input-group">
                <span class="input-group-addon">熱量</span>
                <div class="form-control form-info text-left">{{optionInfo.calorie}} cal</div>
              </div>
              <br />
            </div>
            <div v-if="optionInfo.description">
              <div class="input-group">
                <span class="input-group-addon">描述</span>
                <div class="form-control form-info text-left">{{optionInfo.description}}</div>
              </div>
              <br />
            </div>
            <div v-if="optionInfo.remark">
              <div class="input-group">
                <span class="input-group-addon">備註</span>
                <div class="form-control form-info text-left">{{optionInfo.remark}}</div>
              </div>
              <br />
            </div>
            <div v-if="optionInfo.option_custom_id">
              <div class="input-group ">
                <span class="input-group-addon">POS廠自定義的ID</span>
                <div class="form-control form-info text-left">{{optionInfo.option_custom_id}}</div>
              </div>
              <br />
            </div>
          </div>
          <!-- info end-->
          <!-- form start -->
          <div class="box-body form" v-if="state == 1 || editState">
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>分類</span>
                <div class="form-group">
                  <select class="form-control" v-model="optionInfo.sub_type">
                    <option v-for="option in optionList" :value="option.value">{{option.label}}</option>
                  </select>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>選項名稱</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.name" maxlength="32">
              </div>
              <br />
              <div>
                <div class="input-group">
                  <span class="input-group-addon">調整類別名稱</span>
                  <div class="form-control form-info text-left">{{adjustName}}</div>
                </div>
                <br />
              </div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>排序</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.sort" @keyup="veritySort()" maxlength="4" v-if="state == 1" ref="sort1">
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.sort" @keyup="veritySort()" maxlength="4" v-if="state == 3" ref="sort3">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>必選項目</span>
                <div class="radio text-left h-38" style="border-left: 1px solid #d2d6de;">
                  <label class="m-l-15">
                    <input type="radio" name="mandatoryRadio" value="1" v-model="optionInfo.is_mandatory" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">是</div>
                  </label>
                  <label class="m-l-15">
                    <input type="radio" name="mandatoryRadio" value="0" v-model="optionInfo.is_mandatory" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">否</div>
                  </label>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>常見價格</span>
                <div class="radio text-left h-38" style="border-left: 1px solid #d2d6de">
                  <label class="m-l-15">
                    <input type="radio" name="commonRadio" value="1" v-model="optionInfo.is_common" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">是</div>
                  </label>
                  <label class="m-l-15">
                    <input type="radio" name="commonRadio" value="0" v-model="optionInfo.is_common" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">否</div>
                  </label>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>最低選擇項目個數</span>
                <input class="form-control c-auto" placeholder="" type="text" v-model="optionInfo.min_limit" @keyup="verityMinLimit()" maxlength="9" v-if="state == 1" ref="minLimit1" disabled>
                <input class="form-control c-auto" placeholder="" type="text" v-model="optionInfo.min_limit" @keyup="verityMinLimit()" maxlength="9" v-if="state == 3" ref="minLimit3" disabled>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>最高選擇項目個數</span>
                <input class="form-control c-auto" placeholder="" type="text" v-model="optionInfo.max_limit" @keyup="verityMaxLimit()" maxlength="9"  v-if="state == 1" ref="maxLimit1" disabled>
                <input class="form-control c-auto" placeholder="" type="text" v-model="optionInfo.max_limit" @keyup="verityMaxLimit()" maxlength="9"  v-if="state == 3" ref="maxLimit3" disabled>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>價格</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.price" @keyup="verityPrice()" maxlength="9" v-if="state == 1" ref="price1">
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.price" @keyup="verityPrice()" maxlength="9" v-if="state == 3" ref="price3">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>價格類型</span>
                <div class="form-group">
                  <select class="form-control" v-model="optionInfo.price_type" >
                    <option value="1">免稅價格</option>
                    <option value="3">含稅價格</option>
                  </select>
                </div>
              </div>
              <div class="text-right text-15 text-red">(若無價格則無須更動)</div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">熱量</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.calorie" @keyup="verityCalorie()" v-if="state == 1" ref="calorie1">
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.calorie" @keyup="verityCalorie()" v-if="state == 3" ref="calorie3">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">描述</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.description" maxlength="45">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">備註</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.remark" maxlength="45">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">POS廠自定義的ID</span>
                <input class="form-control" placeholder="" type="text" v-model="optionInfo.option_custom_id" maxlength="30">
              </div>
              <br />
            </div>
          </div>
          <!-- form end-->
        </div>
        <div class="modal-footer" v-if="state != 3 || editState">
          <button type="button" class="btn btn-default" data-dismiss="modal">返回</button>
          <button type="button" class="btn btn-primary" v-if="state == 1" @click="checkInputEmpty()">新增</button>
          <button type="button" class="btn btn-primary" v-if="editState" @click="checkInputEmpty()">編輯</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import $ from 'jquery'
export default {
  props: {
    modalId: {
      type: String,
      required: true
    },
    // 1 = add, 2 = edit, 3 = info
    state: {
      type: Number
    },
    adjustId: {
      type: Number,
      required: true
    },
    adjustName: {
      type: String,
      required: true
    },
    adjustSubType: {
      type: Number
    },
    optionId: {
      type: Number
    }
  },
  data () {
    return {
      editState: false,
      show: {
        delNotify: false
      },
      optionInfo: {
        sort: 1,
        name: '',
        option_custom_id: '',
        description: '',
        remark: '',
        price: 0,
        price_type: '3',
        calorie: '',
        sub_type: '0',
        is_mandatory: '0',
        min_limit: '0',
        max_limit: '1',
        is_common: '0'
      }
    }
  },
  methods: {
    ...mapActions(['setUpAdjust', 'setModal']),
    init () {
      if (typeof this.info !== 'undefined') {
        this.brandName = this.info.name
        this.brandType = this.info.type
      }
    },
    toggle () {
      $(this.$refs.infoCategoryModal).css('display')
    },
    maxAmount (max) {
      if (!max) return '無限制'
      else return max
    },
    getOptionInfo () {
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/option/' + this.optionId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.optionInfo = response.data.option
        }
      })
    },
    getSubType (type) {
      if (type === 10) {
        return '大小(含未知大小)'
      } else if (type === 12) {
        return 'S'
      } else if (type === 14) {
        return 'M'
      } else if (type === 16) {
        return 'L'
      } else if (type === 18) {
        return 'XL'
      } else if (type === 20) {
        return '容器(含未知容器)'
      } else if (type === 30) {
        return '甜度(含未知甜度)'
      } else if (type === 41 || type === 42 || type === 43) {
        return '冰'
      } else if (type === 44 || type === 45 || type === 46) {
        return '溫'
      } else if (type === 47 || type === 48 || type === 49) {
        return '熱'
      } else {
        return '未定義'
      }
    },
    getPriceType (type) {
      if (type === 1) return '免稅價格'
      else if (type === 3) return '含稅價格'
    },
    veritySort () {
      var e
      if (this.state === 1) e = $(this.$refs.sort1)
      else if (this.state === 3) e = $(this.$refs.sort3)
      this.optionInfo.sort = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityMinLimit () {
      var e
      if (this.state === 1) e = $(this.$refs.minLimit1)
      else if (this.state === 3) e = $(this.$refs.minLimit3)
      this.optionInfo.min_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityMaxLimit () {
      var e
      if (this.state === 1) e = $(this.$refs.maxLimit1)
      else if (this.state === 3) e = $(this.$refs.maxLimit3)
      this.optionInfo.max_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityPrice () {
      var e
      if (this.state === 1) e = $(this.$refs.price1)
      else if (this.state === 3) e = $(this.$refs.price3)
      this.optionInfo.price = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityCalorie () {
      var e
      if (this.state === 1) e = $(this.$refs.calorie1)
      else if (this.state === 3) e = $(this.$refs.calorie3)
      this.optionInfo.calorie = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    clearData () {
      this.optionInfo = {
        sort: 1,
        name: '',
        option_custom_id: '',
        description: '',
        remark: '',
        price: 0,
        price_type: '3',
        calorie: '',
        sub_type: '0',
        is_mandatory: '0',
        min_limit: '0',
        max_limit: '1',
        is_common: '0'
      }
    },
    checkInputEmpty () {
      if (!this.optionInfo.sub_type && parseInt(this.optionInfo.sub_type, 10) !== 0) {
        this.$notify({
          title: '提醒',
          text: '請選擇分類',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫調整類別名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.price) {
        this.$notify({
          title: '提醒',
          text: '請填寫價格',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.updateOption()
      }
    },
    updateOption () {
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/option'
      var data = {
        adjust_id: this.adjustId,
        name: this.allInput.name,
        sort: this.allInput.sort,
        min_limit: this.allInput.min_limit,
        max_limit: this.allInput.max_limit,
        price: this.allInput.price,
        price_type: this.optionInfo.price_type,
        sub_type: this.optionInfo.sub_type,
        is_mandatory: this.optionInfo.is_mandatory,
        is_common: this.optionInfo.is_common
      }
      if (this.optionId) data['option_id'] = this.optionId
      if (this.allInput.calorie) data['calorie'] = this.allInput.calorie
      if (this.allInput.vendor_custom_id) data['vendor_custom_id'] = this.allInput.vendor_custom_id
      if (this.allInput.description) data['description'] = this.allInput.description
      if (this.allInput.remark) data['remark'] = this.allInput.remark
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功新增選項',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.editState = false
          var id = self.modalId
          $('#' + id).modal('toggle')
          self.setUpAdjust(true)
        }
      })
    },
    delOption () {
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/option?option_id=' + this.optionId
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功刪除選項',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.editState = false
          var id = self.modalId
          $('#' + id).modal('toggle')
          self.setUpAdjust(true)
        }
      })
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapGetters(['getModal']),
    modalState () {
      if (this.state === 3 && !this.editState) return this.optionInfo.name
      if (this.editState) return '編輯' + this.optionInfo.name
      else return '新增選項'
    },
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    },
    allInput () {
      return {
        name: this.checkInput(this.optionInfo.name),
        sort: this.checkInput(this.optionInfo.sort),
        vendor_custom_id: this.checkInput(this.optionInfo.option_custom_id),
        description: this.checkInput(this.optionInfo.description),
        remark: this.checkInput(this.optionInfo.remark),
        price: this.checkInput(this.optionInfo.price),
        calorie: this.checkInput(this.optionInfo.calorie),
        min_limit: this.checkInput(this.optionInfo.min_limit),
        max_limit: this.checkInput(this.optionInfo.max_limit)
      }
    },
    optionList () {
      var options = []
      if (this.adjustSubType === 0) {
        // 未定義
        options = [
          {label: '未定義', value: 0}
        ]
      } else if (this.adjustSubType === 10) {
        // 大小
        options = [
          {label: '大小(含未知大小)', value: 10},
          {label: 'S', value: 12},
          {label: 'M', value: 14},
          {label: 'L', value: 16},
          {label: 'XL', value: 18},
          {label: '未定義', value: 0}
        ]
      } else if (this.adjustSubType === 20) {
        // 容器
        options = [
          {label: '容器(含未知容器)', value: 20},
          {label: '未定義', value: 0}
        ]
      } else if (this.adjustSubType === 30) {
        // 甜度
        options = [
          {label: '甜度(含未知甜度)', value: 30},
          {label: '無糖', value: 31},
          {label: '微糖', value: 33},
          {label: '半糖', value: 35},
          {label: '少糖', value: 37},
          {label: '全糖', value: 39},
          {label: '未定義', value: 0}
        ]
      } else if (this.adjustSubType === 40) {
        // 溫度
        options = [
          {label: '溫度(含未知溫度)', value: 40},
          {label: '冰', value: 42},
          {label: '溫', value: 45},
          {label: '熱', value: 48},
          {label: '未定義', value: 0}
        ]
      }
      return options
    }
  },
  mounted () {
    var self = this
    $('.modal').on('hidden.bs.modal', function () {
      self.setModal(false)
      self.clearData()
    })
  },
  watch: {
    getModal () {
      if (this.getModal) {
        this.$nextTick(function () {
          this.$set(this.optionInfo, 'is_mandatory', '0')
          this.$set(this.optionInfo, 'is_common', '0')
        })
        this.editState = false
        this.show.delNotify = false
        if (this.optionId && this.state !== 1) {
          this.getOptionInfo()
        }
      }
    }
  }
}
</script>
<style lang="sass">
  $default-color: #e1456d
  $light-gray: rgb(238, 238, 238)
  input[type=checkbox], input[type=radio]
    margin: 0px
  .text-light-gray
    color: $light-gray !important
  .checkbox, .radio
    margin: 0px
  .m-l-15
    margin-left: 15px
  .c-auto, .c-auto:hover
    cursor: auto !important
</style>



// WEBPACK FOOTER //
// OptionModal.vue?82576480